export const companyStatusType = {
    Undefined: 0,
    OnHold: 1,
    Active: 2,
    Blocked: 3,
    Deleted: 4
}